// 이 앱이 돌고 있는 기기(= 이 PC)의 기기 코드 — 가벼운 공용 훅(2026-09-29 사용자 요청).
// 기기 목록·주소록·코드 접속에서 **자기 자신에게 접속하지 못하게** 하려고 쓴다(판정·문구 = `src/deviceCode.ts`).
// `useMyConnection` 도 기기 코드를 이 훅에서 받는다 — 코드 구독을 한 곳에만 둔다.
import { useEffect, useState } from 'react';
import { invoke } from '@tauri-apps/api/core';
import { listen } from '@tauri-apps/api/event';
import { SHELL, IS_SHELL } from '../../shell';

export { isSameDeviceCode, SELF_CONNECT_BLOCKED, SELF_DEVICE_BADGE } from '../../deviceCode';

/** 껍데기 정체성 이벤트 이름·조회 명령. 🔴 Rust 껍데기와 같아야 한다(`useMyConnection` 과 공용). */
export const IDENTITY_EVENT = 'rs-identity';
export const IDENTITY_QUERY = 'current_identity';

/**
 * 이 PC 의 기기 코드. 브라우저 뷰어(껍데기 없음)면 늘 undefined.
 * ⚠️ 반응형이어야 한다 — 무인 서비스에 붙은 모드에서는 앱이 켜질 때 서비스가 아직 없을 수 있고, 뜨는 즉시 코드가 도착한다.
 * 빈 코드가 오면(서비스 중지) undefined 로 되돌린다.
 */
export function useMyDeviceCode(): string | undefined {
  const [code, setCode] = useState<string | undefined>(SHELL.passiveId);
  useEffect(() => {
    if (!IS_SHELL) return;
    const apply = (p: { deviceCode?: string } | null | undefined) => {
      if (p && typeof p.deviceCode === 'string') setCode(p.deviceCode || undefined);
    };
    const un = listen<{ deviceCode?: string }>(IDENTITY_EVENT, (e) => apply(e.payload));
    // 구독 직후 최신값을 직접 묻는다(리스너를 달기 전에 온 갱신 유실 방지).
    invoke<{ deviceCode?: string } | null>(IDENTITY_QUERY).then(apply).catch(() => {});
    return () => {
      void un.then((f) => f());
    };
  }, []);
  return code;
}
